<template>
  <div>
    <Piso/>
  </div>
</template>
<script>
import Piso from '../../canadas/deptos/mapLocation/Piso'
export default {
  name: "PisoMenu",
  components: {
    Piso
  }
}
</script>
<style scoped>
</style>